import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// matchheight
import matchHeight from 'jquery-match-height';
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

document.addEventListener('DOMContentLoaded', () => {
})

window.addEventListener('resize', () => {
})